export const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
   CODE_CHANGE: "conde-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
  TOGGLE_BOT: "toggle-bot",
  LANGUAGE_CHANGE: "language-change",
};
